import { fetchEndpointData } from '@/utils/fetch.client';

import type { PortPreview } from './ports';

/** noVNC's port inside the sandbox. */
export const VNC_PORT = 6080;

/** Start the sandbox's computer-use processes (Xvfb, xfce4, x11vnc, noVNC).
 * They ship in the snapshot but are not running until asked for.
 * `base` is the sandbox resource prefix — see `sandbox-files.ts` for details. */
export async function startComputerUse(base: string): Promise<void> {
  await fetchEndpointData(`${base}/computer-use/start`, { method: 'POST' });
}

/** Signed preview URL for the noVNC port, issued with a session-length expiry so
 * the embedded client survives reconnects (the default 60s signature does not). */
export async function getDesktopPreview(base: string): Promise<PortPreview> {
  return fetchEndpointData<PortPreview>(`${base}/computer-use/preview`);
}
